import React from 'react';

const GreenArrowIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
  >
    <circle cx="12" cy="12" r="12" fill="#5bc2a7" />
    <path
      d="M9.684 7.352a.857.857 0 0 0 0 1.212L12.923 12l-3.239 3.436a.857.857 0 1 0 1.233 1.188l3.857-4.1a.857.857 0 0 0 0-1.188l-3.857-4.1a.857.857 0 0 0-1.233 0Z"
      fill="white"
    />
  </svg>
);

export default GreenArrowIcon;
